import { Dispatch } from 'redux'
import { asanSigningVerify } from '../../../../services/IbSigning/asan'
import { AsanVerifyActions, AsanVerifyActionTypes, AsanVerifyRequest, AsanVerifyResponse } from 'store/reducers/ibsigning/asansigning/verify/types'

export const fetchAsanVerifyRequest = (): AsanVerifyActions => ({
  type: AsanVerifyActionTypes.FETCH_ASAN_VERIFY_REQUEST,
})

export const fetchAsanVerifyFailed = (payload: any): AsanVerifyActions => ({
  type: AsanVerifyActionTypes.FETCH_ASAN_VERIFY_FAILED,
  payload,
})

export const fetchAsanVerifySuccess = (
  payload: AsanVerifyResponse
): AsanVerifyActions => ({
  type: AsanVerifyActionTypes.FETCH_ASAN_VERIFY_SUCCESS,
  payload,
})

export const fetchAsanVerify = (requestBody: AsanVerifyRequest) => {
  return async (dispatch: Dispatch<AsanVerifyActions>) => {
    dispatch(fetchAsanVerifyRequest())

    try {
      const data = await asanSigningVerify(requestBody)
      dispatch(fetchAsanVerifySuccess(data))
    } catch (error: any) {
      dispatch(fetchAsanVerifyFailed(error.message))
    }
  }
}
